import React from 'react'
import {
    ComposedChart,
    ResponsiveContainer,
    Line,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend
} from 'recharts';
import PropTypes from 'prop-types'
import stringToColour from 'string-to-color'

const BudgetChart = ({data, keys}) => {
    //<Line type='monotone' dataKey='uv' stroke='#ff7300'/>
    return (
        <ResponsiveContainer width="100%" height={300}>
            <ComposedChart height={400} data={data}
                           margin={{top: 20, right: 20, bottom: 20, left: 20}}>
                <CartesianGrid stroke='#f5f5f5'/>
                <XAxis dataKey="date"/>
                <YAxis/>
                <Tooltip/>
                <Legend/>
                {keys.map(key => <Bar key={key} dataKey={key} stackId="a" fill={stringToColour(key)}/>)}

            </ComposedChart>
        </ResponsiveContainer>
    );
}

BudgetChart.propTypes = {
    data: PropTypes.array.isRequired
}

export default BudgetChart